import styled, { css } from "styled-components";

const TabsContentStyled = styled.div`
display: none;
/* focused */
    ${props => {
        return (
            props.active &&
            css`
                display: block;
            `
        );
    }}
`;

export default TabsContentStyled;